import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { HistorySidebar } from './HistorySidebar';
import { ChatMainPanel } from './ChatMainPanel';
import { useErrorContext } from '../../contexts/ErrorContext';
import { ChatMessageSender } from './ChatMessageSender';

export type ChatWorkspaceProps = {
  isDarkTheme: boolean;
};

export function ChatWorkspace({
  isDarkTheme,
}: ChatWorkspaceProps) {
  const { errors } = useErrorContext();
  const frontendConfigError = errors.frontendConfig ?? null;
  const assistantError = errors.assistants ?? null;
  return (
    <Box component="div">
      <Box
        sx={{
          minHeight: 'calc(100dvh - 54px)',
          height: 'calc(100dvh - 54px)',
          bgcolor: 'background.default',
          color: 'text.primary',
          backgroundImage: isDarkTheme
            ? 'radial-gradient(circle at 10% 20%, rgba(16,185,129,0.08), transparent 25%), radial-gradient(circle at 80% 10%, rgba(56,189,248,0.08), transparent 25%)'
            : 'radial-gradient(circle at 10% 20%, rgba(37,99,235,0.08), transparent 25%), radial-gradient(circle at 80% 10%, rgba(14,116,144,0.08), transparent 25%)',
          position: 'relative',
          boxSizing: 'border-box',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            maxWidth: { xs: '100%', md: '96vw' },
            width: { xs: '100%', md: '96vw' },
            mx: 'auto',
            px: { xs: 2, md: 4 },
            py: { xs: 1.5, md: 2 },
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            flex: 1,
            minHeight: 0,
            boxSizing: 'border-box',
          }}
        >
          {frontendConfigError && (
            <Typography variant="caption" color="#ff6b6b">
              {`Konfiguration konnte nicht geladen werden: ${frontendConfigError}`}
            </Typography>
          )}
          {assistantError && (
            <Typography variant="caption" color="#ff6b6b">
              {`Assistenten konnten nicht geladen werden: ${assistantError}`}
            </Typography>
          )}
          <Paper
            sx={{
              flex: 1,
              minHeight: 0,
              p: { xs: 2, md: 2.5 },
              height: '100%',
              maxHeight: '100%',
              boxSizing: 'border-box',
              display: 'grid',
              gridTemplateAreas: {
                xs: '"main" "input"',
                md: '"sidebar main" "sidebar input"',
              },
              gridTemplateColumns: { xs: '1fr', md: '340px 1fr' },
              gridTemplateRows: 'minmax(0, 1fr) auto',
              gap: { xs: 2, md: 3 },
            }}
          >
            <Box
              sx={{
                gridArea: 'sidebar',
                display: { xs: 'none', md: 'flex' },
                flexDirection: 'column',
                minHeight: 0,
                maxHeight: '100%',
              }}
            >
              <HistorySidebar />
            </Box>

            <ChatMainPanel />

            <ChatMessageSender />
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}
